import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import MergeBaseConfigListing from './MergeBaseConfigListing'
import MergeBaseCredentialsForm from './MergeBaseCredentialsForm'

export default function MergeBasePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={MergeBaseCredentialsForm}
            PullConfigListingView={MergeBaseConfigListing}
        />
    )
}